<template>
  <article>
    <div id="Quotes">
      <div class="ContentAligher TBSpacing">
        <section class="text-center">

          <div class="row">
            <div class="col-md-12">  
              <h1 class="blue-c-2 ">Recent examples of <br>the MCA business potential</h1>
              <div class="example-list">
                <carousel :items="1"  :nav="false">
                  <div><p class="blue-c-2 font-light">Airbnb, the global home rental giant, is one of the largest digital platforms which has utilised MCAs. The recent partnership between Airbnb and AirAdvance is an excellent example of the potential and demand for such business. AirAdvance provides Airbnb hosts with access to funds advanced against future bookings. </p></div>
                  <div><p class="blue-c-2 font-light">Shopify, one of the leading e-commerce platforms in the world, established Shopify Capital in 2016 to help online retail customers procure financing. According to their 3rd quarter of 2018 earnings report, Shopify Capital issued $76.4 million in merchant cash advances during the reporting period, which is an increase of 73% from the $44.1 million issued in the 3rd quarter of 2017. Shopify Capital has grown to nearly $375 million in cumulative cash advance provided since its launch.</p></div>
                  <div><p class="blue-c-2 font-light">Online payment gateways, such as Paypal and Square, are also leveraging on the MCA potential. As per recent reports, Square Capital has lent over 60,000 business loans totalling to $390 million (a growth of 22% year-over-year).  </p></div>
                </carousel>
              </div>
            </div>
          </div>

      </section>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'Quotes',
  data () {
    return {
      title: 'Interested in investing with  Dan Advance?'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Quotes.vue